import Choices from 'choices.js'
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['countrySelect', 'citySelect']
  static values = {
    citiesEndpoint: String
  }

  connect() {
    this.initializeChoices();
    this.setupCountryCityReactivity();
  }

  initializeChoices() {
    const selects = document.querySelectorAll('select')
    selects.forEach(select => {
      const choicesInstance = new Choices(select, {
        searchResultLimit: 50,
        position: 'bottom',
        searchEnabled: true,
        shouldSort: true
      });

      // Store the choices instance on the select element for later access
      select._choicesjs = choicesInstance;
    })
  }

  setupCountryCityReactivity() {
    if (this.hasCountrySelectTarget && this.hasCitySelectTarget) {
      this.countrySelectTarget.addEventListener('change', this.handleCountryChange.bind(this));
    }
  }

  async handleCountryChange(event) {
    const selectedCountryCode = event.detail.value;
    const citySelect = this.citySelectTarget;

    // Always clear the city value when country changes
    this.clearCityValue();

    if (!selectedCountryCode) {
      this.clearCityOptions();
      return;
    }

    try {
      this.showCityLoading();
      const cities = await this.fetchCitiesFromAPI(selectedCountryCode);
      this.updateCityOptions(cities);
    } catch (error) {
      console.error('Error fetching cities:', error);
      this.showCityError();
    }
  }

  clearCityValue() {
    const citySelect = this.citySelectTarget;
    const choicesInstance = citySelect._choicesjs;

    if (choicesInstance) {
      // For single select, use removeActiveItems to clear selection
      choicesInstance.removeActiveItems();
    } else {
      // Fallback for regular select
      citySelect.value = '';
    }
  }

  async fetchCitiesFromAPI(countryCode) {
    const response = await fetch(`${this.citiesEndpointValue}?country_code=${countryCode}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const cities = await response.json();

    // Transform the array of city names into the format expected by Choices.js
    return cities.map(city => ({
      value: city,
      label: city
    }));
  }

  updateCityOptions(cities) {
    const citySelect = this.citySelectTarget;
    const choicesInstance = citySelect._choicesjs;

    if (choicesInstance) {
      // Clear existing options
      choicesInstance.clearChoices();

      // Add new options
      choicesInstance.setChoices(cities, 'value', 'label', true);
    } else {
      // Fallback for regular select
      citySelect.innerHTML = '<option value="">Select a city...</option>';
      cities.forEach(city => {
        const option = document.createElement('option');
        option.value = city.value;
        option.textContent = city.label;
        citySelect.appendChild(option);
      });
    }
  }

  clearCityOptions() {
    const citySelect = this.citySelectTarget;
    const choicesInstance = citySelect._choicesjs;

    if (choicesInstance) {
      choicesInstance.clearChoices();
      choicesInstance.setChoices([{ value: '', label: 'Select a city...' }], 'value', 'label', true);
    } else {
      citySelect.innerHTML = '<option value="">Select a city...</option>';
    }
  }

  showCityLoading() {
    const citySelect = this.citySelectTarget;
    const choicesInstance = citySelect._choicesjs;

    if (choicesInstance) {
      choicesInstance.setChoices([{ value: '', label: 'Loading cities...' }], 'value', 'label', true);
    } else {
      citySelect.innerHTML = '<option value="">Loading cities...</option>';
    }
  }

  showCityError() {
    const citySelect = this.citySelectTarget;
    const choicesInstance = citySelect._choicesjs;

    if (choicesInstance) {
      choicesInstance.setChoices([{ value: '', label: 'Error loading cities' }], 'value', 'label', true);
    } else {
      citySelect.innerHTML = '<option value="">Error loading cities</option>';
    }
  }
}
